import Axios from "axios"

export const validateVatId = (vatId) => {
	return new Promise((resolve, reject) => {
		Axios.post('/configurator/checkVat', {
			vat_id: vatId
		})
			.then(response => {
				resolve(response.data.valid === 1)
			})
			.catch(err => {
				reject(false)
			})
	})
}